import createReactComponent from '../createReactComponent';
export default createReactComponent('egg', 'Egg', [["path",{"d":"M12 21c4.004 0 7.25-3.224 7.25-7.2S16.004 3 12 3 4.75 9.824 4.75 13.8 7.996 21 12 21","key":"svg-0"}]]);